import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { Servers } from '../services/http/server';

export interface SiteConfig {
    menuItems: any[];
    homePageImageSlider: [];
    topCollection: [];
  }

 const DEFAULT_CONFIG: SiteConfig = {
    menuItems: [
      {
        title: 'Men',
        url: "products?collections=mens",
        items: [
          { title: 'T-Shirts', url: "products?collections=men-tshirts" },
          { title: 'Tracks', url: "products?collections=men-tracks" },
          { title: 'Shorts', url: "products?collections=men-shorts" },
        ]
      },
      {
        title: 'Women',
        url: "products?collections=womens",
        items: [
          { title: 'T-Shirts', url: "products?collections=women-tshirts" },
          { title: 'Sports Bra', url: "products?collections=women-sports-bra" }
        ]
      },
      {
        title: 'Junior',
        url: "products?collections=juniors",
        items: [
          { title: 'T-Shirts', url: "products?collections=juniors-tshirts" },
          { title: 'Tracks', url: "products?collections=juniors-tracks" },
          { title: 'Shorts', url: "products?collections=juniors-shorts" },
        ]
      },
      {
        title: 'Custom',
        url: "products?collections=custom",
        items: [
          { title: 'Tees', url: "products?collections=custom-tees" },
          { title: 'Tracks', url: "products?collections=custom-tracks" },
          { title: 'Shorts', url: "products?collections=custom-shorts" },
        ]
      },
    ],
    homePageImageSlider: [],
    topCollection: [],    
 };

// 🔄 Async thunk to fetch & merge config
export const fetchSiteConfig = createAsyncThunk('siteConfig/fetch', async () => {
  const [site] = await Promise.all([
    fetch(Servers.FILE_URL+"/"+Servers.TENANTID+"/site-config.json").then((res) => res.json())    
  ]);

  const mergedConfig = {
    ...DEFAULT_CONFIG,
    ...site,    
  };

  localStorage.setItem('siteConfig', JSON.stringify(mergedConfig));
  return mergedConfig;
});

const siteConfigSlice = createSlice({
  name: 'siteConfig',
  initialState: DEFAULT_CONFIG,
  reducers: {
    setSiteConfig(state, action: PayloadAction<SiteConfig>) {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSiteConfig.fulfilled, (_state, action) => action.payload);
  },
});

export const { setSiteConfig } = siteConfigSlice.actions;
export default siteConfigSlice.reducer;
